import * as React from "react";
import TextField from "../core/TextField";
import { getContacts, getEmailFromContact } from "../../libs/chartec_cw";
import { debounce } from "lodash";
import CenterDiv from "../core/CenterDiv";

interface IProps {
  onSelect: (contact: ICtGetContactsResult) => void;
  companyRecId: string;
}

interface IState {
  contactResults: ICtGetContactsResult[];
  searching: boolean;
  firstName: string;
  lastName: string;
}

class PickCwContact extends React.Component<IProps, IState> {
  _isMounted = false;

  state: Readonly<IState> = {
    searching: false,
    contactResults: [],
    firstName: "",
    lastName: "",
  };

  componentDidMount() {
    this.getContacts();
    this._isMounted = true;
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  getContacts = async () => {
    if (this._isMounted) {
      const { firstName, lastName } = this.state;
      this.setState({ searching: true });
      const result = await getContacts(this.props.companyRecId, {
        firstName,
        lastName,
      });
      this.setState({ contactResults: result.contacts, searching: false });
    }
  };

  debouncedGetContacts = debounce(this.getContacts, 300);

  updateFirstName = (firstName: string) =>
    this.setState({ firstName }, this.debouncedGetContacts);
  updateLastName = (lastName: string) =>
    this.setState({ lastName }, this.debouncedGetContacts);

  render() {
    const { firstName, lastName, contactResults, searching } = this.state;
    const { onSelect } = this.props;

    return (
      <>
        <div className="columns">
          <div className="column">
            <TextField
              label={"First Name"}
              value={firstName}
              onChange={e => this.updateFirstName(e.target.value)}
            />
          </div>
          <div className="column">
            <TextField
              label={"Last Name"}
              value={lastName}
              onChange={e => this.updateLastName(e.target.value)}
            />
          </div>
        </div>
        {searching ? (
          <CenterDiv>
            <i className="fa fa-spin fa-3x fa-circle-o-notch" />
          </CenterDiv>
        ) : (
          <table className={"table"}>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Title</th>
                <th>Email</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {contactResults.map(c => (
                <tr key={c.id}>
                  <td>{c.firstName}</td>
                  <td>{c.lastName}</td>
                  <td>{c.title}</td>
                  <td>{getEmailFromContact(c)}</td>
                  <td>
                    <button
                      className="btn btn-theme-primary"
                      onClick={() => onSelect(c)}
                    >
                      Choose
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </>
    );
  }
}

export default PickCwContact;



// WEBPACK FOOTER //
// ./app/javascript/components/org/PickCwContact.tsx